import * as S from './styles';

const MenuImageSkeleton = () => {
    return <S.ImageWrap />
};

export default MenuImageSkeleton;